import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { CommentItem } from "./CommentItem";
import { useLoadMore } from "@/hooks/useLoadMore";
import { getStaffCommentLists } from "@/api/staff";
import type { StaffCommentItem } from "@/api/staff";

const BRAND = "#FF6B35";

export default function CommentPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const uid = Number(searchParams.get("uid") || 0);

  const { list, loading, hasMore, containerRef, reload, total } = useLoadMore<StaffCommentItem>({
    fetcher: async (page) => {
      const res = await getStaffCommentLists({ uid, page, limit: 10 });
      return { list: res.list || [], total: res.count || 0, page, limit: 10 };
    },
    deps: [uid],
    pageSize: 10,
  });

  return (
    <div className="min-h-screen" style={{ background: "#F7F7F7", fontFamily: "'SF Pro Text','PingFang SC','Inter',system-ui,sans-serif" }}>
      {/* Header — 橙色品牌色背景（与原版一致） */}
      <div style={{ background: BRAND }}>
        <div className="px-5 flex items-center gap-3" style={{ paddingTop: "calc(env(safe-area-inset-top,0px) + 16px)", paddingBottom: 13 }}>
          <button onClick={() => navigate(-1)} className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer active:scale-[0.98] shrink-0" style={{ background: "rgba(255,255,255,0.2)" }}>
            <i className="ri-arrow-left-line" style={{ fontSize: 20, color: "#fff" }} />
          </button>
          <span className="text-lg font-bold text-white">评价记录</span>
        </div>
      </div>

      {/* 可滚动区域 */}
      <div
        ref={containerRef}
        className="p-[10px] box-border flex flex-col gap-[10px]"
        style={{ height: "calc(100vh - 56px)", overflowY: "auto" }}
      >
        {/* 列表 */}
        {list.map((item) => (
          <CommentItem key={item.id} item={item} />
        ))}

        {!list.length && !loading && (
          <div className="pt-[60px] text-center">
            <i className="ri-star-line text-5xl block mx-auto mb-3 text-gray-200" />
            <p className="text-sm text-gray-400">暂无评价记录</p>
          </div>
        )}

        {loading && (
          <div className="py-4 text-center text-xs text-gray-400">
            <i className="ri-loader-4-line text-lg animate-spin block mx-auto mb-1" />
            加载中...
          </div>
        )}

        {!loading && list.length > 0 && !hasMore && (
          <div className="py-4 text-center text-xs text-gray-300">— 已加载全部 —</div>
        )}
      </div>
    </div>
  );
}
